// extracted by mini-css-extract-plugin
export var indeterminate = "_3y-6";
export var md = "_3y-5";
export var semantic = "_3y-7";
export var sm = "_3y-4";
export var text = "_3y-8";
export var toggleControl = "_3y-0";
export var toggleInput = "_3y-1";
export var toggleSwitch = "_3y-2";
export var xs = "_3y-3";